import { render, staticRenderFns } from "./com-container.vue?vue&type=template&id=3a5d748e&scoped=true"
import script from "./com-container.vue?vue&type=script&lang=js"
export * from "./com-container.vue?vue&type=script&lang=js"
import style0 from "./com-container.vue?vue&type=style&index=0&id=3a5d748e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d748e",
  null
  
)

export default component.exports